import { RowSelectionOptions } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { FeatureChoice } from 'app/model/entities/entity-model';
import { ISortModel } from 'app/shared/ag-fns';
import { DbQueryService } from 'app/shared/db-query.service';
import { EntityFinderDialog, EntityFinderParams } from 'app/shared/entity-finder.dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface FeatureChoiceFinderParams extends EntityFinderParams {
  featureId: number;
  excludedFeatureChoiceIds: number[];
  rowSelection?: RowSelectionOptions ; // default is single
}


@Component({
    template: EntityFinderDialog.HTML,
    host: { 'hostID': crypto.randomUUID().toString() },
    standalone: false
})
export class FeatureChoiceFinderDialogComponent extends EntityFinderDialog<FeatureChoice, FeatureChoiceFinderParams> {

  constructor(
    ref: DynamicDialogRef,
    config: DynamicDialogConfig<FeatureChoiceFinderParams>,
    public dbQueryService: DbQueryService,
  ) {
    super(ref, config);

    Object.assign(this.config, {
      header: `Select Feature Choices`,
      height: '530px',
      width: '800px',
      rowModelType: 'clientSide'
    });
  }

  override async initDatasource() {
    let featureChoices = await this.dbQueryService.getFeatureChoices(this.params.featureId);
    var excludedIds = new Set(this.params.excludedFeatureChoiceIds);
    featureChoices = featureChoices.filter(x => !excludedIds.has(x.id));
    return featureChoices
  }

  override getColDefsAndSortModel() {
    const colDefs = [
      { headerName: 'Value', field: 'choiceValue', filter: 'agTextColumnFilter',  },
      { headerName: 'Display Order', field: 'displayOrder', hide: true },
    ];
    const sortModel = [
      { colId: 'displayOrder', sort: 'asc' },
    ] as ISortModel;
    return [colDefs, sortModel] as const;
  }

  
}
